import React from "react";
import { Link } from "react-router-dom";

const proofItems = [
  {
    label: "Habilitations",
    title: "Documents consultables",
    text: "Les agréments et pièces publiques sont accessibles avant le premier échange.",
  },
  {
    label: "Méthode",
    title: "Cadrage avant proposition",
    text: "Chaque demande est orientée selon le besoin, le pays, le délai et le profil du client.",
  },
  {
    label: "Terrain",
    title: "Interventions multi-pays",
    text: "Une présence entre le Maroc, la Côte d'Ivoire et des relais internationaux.",
  },
];

export default function PremiumProof({ content = {} }) {
  const items = content.items || proofItems;

  return (
    <section className="premium-proof-band">
      <div className="container">
        <div className="premium-proof-layout">
          <div className="premium-proof-copy">
            <p className="section-kicker mb-3">
              {content.kicker || "Signaux de confiance"}
            </p>
            <h2 className="section-heading">
              {content.title || "Des éléments concrets pour décider avec sérénité."}
            </h2>
            <p>
              {content.description ||
                "Avant de solliciter une mission, vos équipes peuvent vérifier nos documents, comprendre notre méthode et choisir le bon canal de contact."}
            </p>
            <div className="premium-proof-actions">
              <Link to="/documents" className="btn btn-outline-dark">
                {content.primaryCta || "Consulter les documents"}
              </Link>
              <Link to="/contact" className="btn btn-success">
                {content.secondaryCta || "Qualifier ma demande"}
              </Link>
            </div>
          </div>

          <div className="premium-proof-grid">
            {items.map((item) => (
              <article className="premium-proof-card" key={item.title}>
                <span>{item.label}</span>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
